import ArrayUtils from "../../utils/array";
import LocalSettingsProto from "../../settings/local-settings/local-settings-v3";

const debug = false
// const debug = "ExpandState"

export default class CollapseState extends LocalSettingsProto {

    // private localSettings: LocalSettingsProto
    public collapsed             : any[]     = []

    constructor(localStorageKey:string) {
        super(localStorageKey, {})
    }

    normalize(value:any) {
        this.collapsed          = _.get(value,'collapsedItems', [])
    }

    toObject() {
        return {
            collapsedItems      : this.collapsed
        }
    }

    isCollapsed(id:ID) {
        return this.collapsed.includes(id)
    }

    toggle(id:ID) {
        this.collapsed = ArrayUtils.toggleArrayValue(this.collapsed, id)
    }

    expand(id:ID) {
        this.collapsed = ArrayUtils.addValueToArray(this.collapsed, id)
    }

    collapse(id:ID) {
        this.collapsed = ArrayUtils.removeValueFromArray(this.collapsed, id)
    }

    // remove collapsed goals ids that are no longer present in goals collection
    clearRedundant(ids:ID[]) {
        const clearedIds = _.intersection(this.collapsed, ids)
        if (!_.isEqual(clearedIds, this.collapsed)) {
            this.collapsed = _.intersection(this.collapsed, ids)
        }
    }
}
